<template>
    <div v-if="showBanner" class="sale-banner">
      <div class="relative flex flex-wrap items-center justify-center px-2 md:py-4 py-4 overflow-hidden font-bold text-center text-white bg-lifeboost-orange-100 border-b-2 gap-y-1.5 border-lifeboost-orange-dark">
        <span class="z-20 flex items-center px-2 text-xl leading-none rounded sm:text-lg md:text-xl gap-x-2 font-ww-medium"> 
          <span class="-mt-1 text-2xl">🎉</span> {{ saleText }} <span class="-mt-1 text-2xl">🎁</span>   
        </span>
        
        <svg
          v-for="(position, index) in positionList"
          :key="index"
          class="absolute opacity-20 floating-percentage lg:opacity-80 2xl:opacity-100 md:opacity-60"
          width="40px"
          height="40px"
          viewBox="0 0 24 24"
          :style="position"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path fill="#E48414" d="M16 17H5V7h11l3.55 5m-1.92-6.16C17.27 5.33 16.67 5 16 5H5c-1.1 0-2 .9-2 2v10a2 2 0 0 0 2 2h11c.67 0 1.27-.34 1.63-.85L22 12zM13.8 8L15 9.2L8.2 16L7 14.8m1.45-6.77c.78 0 1.42.64 1.42 1.42s-.64 1.42-1.42 1.42s-1.42-.64-1.42-1.42s.64-1.42 1.42-1.42m5.1 5.1c.78 0 1.42.64 1.42 1.42s-.64 1.42-1.42 1.42s-1.42-.64-1.42-1.42s.64-1.42 1.42-1.42"/>
        </svg>
      </div>
    </div>
  </template>
  
  <script setup>
  import { ref, computed } from 'vue';
  
  // List of positions
  const positions = [
    "top:30px; left:30px",
    "top:30px; right:30px",
    "bottom:20px; left:50px",
    "bottom:20px; right:50px",
    "top:50%; left:25%",
    "top:50%; right:25%",
    "bottom:50%; left:30%",
    "bottom:50%; right:30%"
  ];
  
  // Compute positions as style objects
  const positionList = computed(() => 
    positions.map(position => 
      position.split(';').reduce((styleObj, stylePair) => {
        const [key, value] = stylePair.split(':');
        styleObj[key.trim()] = value.trim();
        return styleObj;
      }, {})
    )
  );
  

// Destructure functions from the composable
const { getSaleTextAndVisibility } = useTimeBasedContent();

// Get sale text and banner visibility
const { text: saleText, visible: showBanner } = getSaleTextAndVisibility();
  </script>
  
  <style scoped>
  
  .floating-percentage {
    animation: float 5s infinite;
  }
  
  @keyframes float {
    0% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-20px);
    }
    100% {
      transform: translateY(0);
    }
  }
  </style>
  